import { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import ReactRouterPropTypes from 'react-router-prop-types';

import CheckoutForm from 'components/checkout_form';
import { getPaymentIntentByStripeId } from 'api/stripe';
import { withRouter } from 'react-router-dom';

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY,
);

const CheckoutPage = ({ history }) => {
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const paymentIntentStripeId = new URLSearchParams(
        window.location.search,
      ).get('payment_intent');

      const paymentIntent = await getPaymentIntentByStripeId(
        paymentIntentStripeId,
      );
      setLoading(false);
      if (paymentIntent.id) {
        setPaymentIntent(paymentIntent);
      }

      const params = new URLSearchParams({
        payment_intent_client_secret: paymentIntent.client_secret,
        payment_intent: paymentIntent.id,
      });
      history.push({
        pathname: '/checkout',
        search: params.toString(),
      });
    }
    fetchData();
  }, [history]);

  const options = {
    clientSecret: paymentIntent?.client_secret,
    appearance: { theme: 'stripe' },
  };

  return (
    <div className="center mw-100">
      {!loading && paymentIntent && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm paymentIntent={paymentIntent} />
        </Elements>
      )}
      {!loading && !paymentIntent && (
        <div className="center h1 pa50">No payment was found.</div>
      )}
    </div>
  );
};

CheckoutPage.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(CheckoutPage);
